<template>
  <FormField class="PhoneField"
    v-bind="{ checkInvalid, checkValid, status, disabled }"
    v-model="value"
    :title="localeStrings.phone.title"
    :placeholder="localeStrings.phone.placeholder"
    :errorMessage="localeStrings.errorMessages.phone"
  />
</template>

<script>
import strings from './strings.json'
import FormField from './FormField.vue'

function testPhone(value) {
  const regExp = /^[EXText.+#\-()\d\s]{7,25}$/
  return regExp.test(value.trim())
}

export default {
  components: {
    FormField,
  },
  props: {
    disabled: Boolean,
  },
  inject: ['locale'],
  data() {
    return {
      status: 'pending',
      value: '',
    }
  },
  computed: {
    localeStrings() {
      return strings[this.locale]
    },
  },
  methods: {
    checkValid() { if (testPhone(this.value)) this.status = 'valid' },
    checkInvalid() { if (!testPhone(this.value)) this.status = 'invalid' },
  },
}
</script>
